//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Boolean",
  props: ["value"],
  data: () => ({
    selectedValue: null,
    comparisonOperator: null,
    comparisonList: [
      { label: "Igual", value: "=" },
      { label: "Diferente", value: "!=" },
      { label: "Valor Nulo", value: "= null" },
      { label: "Valor não Nulo", value: "!= null" }
    ],
    valueList: [
      { label: "Verdadeiro", value: "true" },
      { label: "Falso", value: "false" },
    ]
  }),
  mounted: function () {
    if (this.value) {
      this.selectedValue = this.value.value;
      this.comparisonOperator = this.comparisonList.find(e => e.value === this.value.comparisonOperator);
    }
  },
  computed: {
    //Disables the value input if no operator is chosen or the null operators are selected
    hasSelectedOperator: {
      get() {
        return this.comparisonOperator == null || this.comparisonOperator.value == "= null" || this.comparisonOperator.value == "!= null"
      }
    }
  },
  methods: {
    updateValues: function () {
      if (this.comparisonOperator.value == "= null" || this.comparisonOperator.value == "!= null") {
        this.$emit("input", {
          ...this.value,
          value: null,
          comparisonOperator: this.comparisonOperator.value
        });
        this.selectedValue = null;
      } else {
        this.$emit("input", {
          ...this.value,
          value: this.selectedValue,
          comparisonOperator: this.comparisonOperator.value
        });
      }
    }
  },
  watch: {
    value: function () {
      if (this.value != null && (this.value.value != this.selectedValue || this.value.comparisonOperator != this.comparisonOperator)) {
        this.comparisonOperator = this.comparisonList.find(e => e.value === this.value.comparisonOperator);
        this.selectedValue = this.value.value;
      }
    }
  }
};
